<template>
    <div>
        <rkm-layout-body title="Lista para entrada inicial">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'almoxarifado-relatorio-entrada-index' })"
                    authorize="index-almoxarifado-relatorio-entrada"
                    color="primary"
                >
                    Relatório de entrada
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </div>
</template>

<script>
import List from '@/components/almoxarifado/entrada-inicial/List'

export default {
    components: { List },
}
</script>